module.exports = __webpack_public_path__ + "media/images/webinar-1-d751c358244b308b46758cfc8b1c16d9.png";